<template>
	<div>
		<v-data-table
			v-if="hasItens"
			v-model="itensAditivoApostilaSelecionados"
			:headers="colunas"
			:items="itensAditivoApostila"
			show-select
			:server-items-length="totalItens"
			item-key="id"
			:options="paginacaoInterna"
			hide-default-footer
			:item-class="getItemClass"
			no-data-text="Nenhum item por aqui"
			class="arp-listview row-pointer"
			@keydown.native="tratarNavegacaoPorEnter"
		>
			<template #[`header.data-table-select`]="{}">
				<v-simple-checkbox
					v-if="!aditivoApostila.isEfetivado"
					:value="itensAditivoApostilaSelecionados.length === totalItens"
					:indeterminate="
						itensAditivoApostilaSelecionados.length > 0 &&
						itensAditivoApostilaSelecionados.length < totalItens
					"
					color="primary"
					@input="onSelectAll($event)"
				></v-simple-checkbox>
			</template>
			<template #[`item.data-table-select`]="{ isSelected, select, item }">
				<v-simple-checkbox
					v-if="!estaCancelado(item)"
					id="caixaDeSelecaoAditivoApostilaItens"
					class="row-checkbox"
					color="primary"
					:value="isSelected"
					@input="select($event)"
					@click.stop
				></v-simple-checkbox>
			</template>
			<template #item.isCancelado="{ item }">
				<icone-tooltip
					v-if="estaCancelado(item)"
					icone="mdi-close-circle"
					cor="grey"
					texto="Cancelado"
					tamanho="16px"
				></icone-tooltip>
			</template>
			<template #item.itemAta.descricao="{ item }">
				<texto-tooltip
					:class="{ 'text-decoration-line-through': estaCancelado(item) }"
					:texto="item.itemAta.descricao"
					:tamanho-maximo="30"
				></texto-tooltip>
			</template>
			<template #item.itemAta.fornecedor.razaoSocial="{ item }">
				<texto-tooltip :texto="getFornecedor(item)" :tamanho-maximo="20"></texto-tooltip>
			</template>

			<template #item.novoFornec="{ item }">
				<template v-if="aditivoApostila.isEfetivado || estaCancelado(item)">
					<texto-tooltip :texto="getFornecedorNovo(item)" :tamanho-maximo="20"></texto-tooltip>
				</template>
				<template v-else>
					<alterar-detentor-item-aditivo-apostila
						:item-selecionado="item"
						:disabled="aditivoApostila.isEfetivado || estaCancelado(item)"
					></alterar-detentor-item-aditivo-apostila>
				</template>
			</template>
			<template #item.itemAta.estoqueAtual="{ item }">
				<span class="pr-2" v-if="!estaCancelado(item)">
					{{ getSaldo(item) | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}
				</span>
			</template>
			<template #item.novoSaldo="{ item }">
				<span class="pr-2" v-if="!estaCancelado(item)">
					{{ item.novoSaldo | rpCurrencyFilter('', numeroCasasDecimaisQtde) }}
				</span>
			</template>
			<template #item.valor="{ item }">
				<span class="pr-2">
					{{ getValor(item) | azCurrency(numeroCasasDecimaisValores) }}
				</span>
			</template>
			<template #item.itemAta.fornecedor.marca="{ item }">
				<texto-tooltip :texto="getMarca(item)" :tamanho-maximo="20"></texto-tooltip>
			</template>
			<template #item.novaMarca="{ item }">
				<alterar-marca-item-aditivo-apostila
					v-if="!estaCancelado(item)"
					:item-selecionado="item"
					:disabled="aditivoApostila.isEfetivado || estaCancelado(item)"
				>
				</alterar-marca-item-aditivo-apostila>
			</template>
			<template #item.itemAta.valorUnitario="{ item }">
				<span> {{ item.valorUnitario | azCurrency(numeroCasasDecimaisQtde) }} </span>
			</template>
			<template #item.novoValor="{ item }">
				<alterar-valor-item-aditivo-apostila
					v-if="!estaCancelado(item)"
					:item-selecionado="item"
					:disabled="aditivoApostila.isEfetivado || estaCancelado(item)"
				></alterar-valor-item-aditivo-apostila>
			</template>
			<template #item.acoes="{ item }">
				<botao-remover-item-aditivo-apostila
					v-if="!estaCancelado(item)"
					v-az-auth="permissoes.itemAditivoApostilaExcluir"
					:item="item"
					@excluir="excluir"
				>
				</botao-remover-item-aditivo-apostila>
				<botao-descancelar-item-aditivo-apostila
					v-if="estaCancelado(item) && !aditivoApostila.isEfetivado"
					v-az-auth="permissoes.itemAditivoApostilaCancelarDescancelar"
					:item="item"
					@descancelar="cancelarDescancelar"
				></botao-descancelar-item-aditivo-apostila>
			</template>
		</v-data-table>

		<template-listagem-vazia
			:total-itens="totalItens"
			:textos="textosDoTemplateDaListagemVazia"
		></template-listagem-vazia>

		<paginacao-tabela
			v-if="hasItens"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			:totalPaginas="totalPaginas"
			:totalItens="totalItens"
			@resetar-page="resetarPage"
		></paginacao-tabela>
	</div>
</template>

<script>
import tabelaMixin from '@/views/mixins/tabela'
import { TabelaColunaUtils } from '@/core/utils'
import TextoTooltip from '@/views/components/TextoTooltip.vue'
import AlterarDetentorItemAditivoApostila from './alterar-detentor/AlterarDetentorItemAditivoApostila.vue'
import { mapState } from 'vuex'
import AlterarMarcaItemAditivoApostila from './alterar-marca/AlterarMarcaItemAditivoApostila.vue'
import AlterarValorItemAditivoApostila from './alterar-valor/AlterarValorItemAditivoApostila.vue'
import { mutationTypes, situacoes } from '@/core/constants'
import BotaoRemoverItemAditivoApostila from '@/views/pages/ata/acessar/aditivo-apostila/primeira-etapa/listagem/botao-remover/BotaoRemoverItemAditivoApostila.vue'
import PaginacaoTabela from '@/views/components/PaginacaoTabela.vue'
import TemplateListagemVazia from '@/views/components/TemplateListagemVazia.vue'
import permissoesMixin from '@/views/mixins/permissoes-mixin'
import IconeTooltip from '@/views/components/IconeTooltip.vue'
import BotaoDescancelarItemAditivoApostila from '@/views/pages/ata/acessar/aditivo-apostila/primeira-etapa/listagem/botao-descancelar/BotaoDescancelarItemAditivoApostila.vue'

export default {
	name: 'primeira-etapa-aditivo-apostila-listagem',
	components: {
		BotaoDescancelarItemAditivoApostila,
		IconeTooltip,
		TemplateListagemVazia,
		PaginacaoTabela,
		BotaoRemoverItemAditivoApostila,
		AlterarMarcaItemAditivoApostila,
		AlterarValorItemAditivoApostila,
		AlterarDetentorItemAditivoApostila,
		TextoTooltip,
	},
	mixins: [tabelaMixin, permissoesMixin],
	props: {
		itensAditivoApostila: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			textosDoTemplateDaListagemVazia: {
				titulo: 'Nenhum item de aditivo/apostila por aqui',
			},
			paginacaoInterna: this.paginacao,
		}
	},
	computed: {
		...mapState({
			aditivoApostila: (state) => state.aditivoApostila,
		}),
		situacaoAditivoApostila() {
			return this.aditivoApostila.situacao
		},
		numeroCasasDecimaisQtde: {
			get() {
				return this.aditivoApostila.numeroCasasDecimaisQtde
			},
		},
		numeroCasasDecimaisValores: {
			get() {
				return this.aditivoApostila.numeroCasasDecimaisValores
			},
		},
		itensAditivoApostilaSelecionados: {
			get() {
				return this.$store.state.itemAditivoApostila.itensAditivoApostilaSelecionados
			},
			set(item) {
				this.$store.commit(mutationTypes.ITEM_ADITIVO_APOSTILA.ITEM_ADITIVO_APOSTILA_SELECIONADO, item)
			},
		},
		isSelecionouTodosItensAditivoApostila: {
			get() {
				return this.$store.state.itemAditivoApostila.isSelecionouTodosItensAditivoApostila
			},
		},
		colunas() {
			const colunas = [
				new TabelaColunaUtils('Tipo', 'itemAta.tipo', '10%'),
				new TabelaColunaUtils('Seq', 'itemAta.sequencia', '10%'),
				new TabelaColunaUtils('', 'isCancelado', '1%'),
				new TabelaColunaUtils('Descrição', 'itemAta.descricao', '10%'),
				new TabelaColunaUtils('Fornecedores', 'itemAta.fornecedor.razaoSocial', '10%'),
				new TabelaColunaUtils('Novo Detentor', 'novoFornec', '12%'),
				new TabelaColunaUtils('Saldo Atual', 'itemAta.estoqueAtual', '5%'),
				new TabelaColunaUtils('Novo Saldo', 'novoSaldo', '5%'),
				new TabelaColunaUtils('Marca', 'itemAta.fornecedor.marca', '10%'),
				new TabelaColunaUtils('Nova Marca', 'novaMarca', '11%'),
				new TabelaColunaUtils('Valor', 'valor', '5%'),
				new TabelaColunaUtils('Novo Valor', 'novoValor', '10%'),
			]

			if (this.verificarPermissao(this.permissoes.itemAditivoApostilaExcluir)) {
				colunas.push(new TabelaColunaUtils('Ações', 'acoes', '5%'))
			}
			return colunas
		},
	},
	methods: {
		resetarPage() {
			this.$emit('resetar-page')
		},
		tratarNavegacaoPorEnter(evento) {
			if (evento.key !== 'Enter') return
			if (!evento.target || typeof evento.target.closest !== 'function') return

			const elementoComId = evento.target.closest('[id^="item-aditivo-apostila"]')
			if (!elementoComId) return

			const idElemento = elementoComId.id
			const regexElemento = /^item-aditivo-apostila(\d+)-(nova-marca|novo-valor)$/
			const resultado = idElemento.match(regexElemento)
			if (!resultado) return

			evento.preventDefault()

			const idItemAtual = Number(resultado[1])
			const tipoColuna = resultado[2]
			const indexItemAtual = this.itensAditivoApostila.findIndex((item) => item.id === idItemAtual)
			if (indexItemAtual < 0) return

			const deslocamento = evento.shiftKey ? -1 : 1
			const itemAlvo = this.itensAditivoApostila[indexItemAtual + deslocamento]
			if (!itemAlvo) return

			const idProximoCampo = `item-aditivo-apostila${itemAlvo.id}-${tipoColuna}`
			this.focarCampoEdicao(idProximoCampo)
		},
		focarCampoEdicao(idCampo) {
			const elemento = document.getElementById(idCampo)
			if (!elemento) return

			const input = elemento.tagName === 'INPUT' ? elemento : elemento.querySelector('input')
			if (!input) return

			input.focus()
			input.select()
		},
		getMarca(item) {
			if (this.aditivoApostila.isEfetivado && item.antigaMarca) {
				return item.antigaMarca
			}
			return item.itemAta.fornecedor.marca
		},

		getValor(item) {
			if (this.aditivoApostila.isEfetivado && item.antigoValor) {
				return item.antigoValor
			}
			return item.itemAta.valorUnitario
		},

		getFornecedor(item) {
			if (this.aditivoApostila.isEfetivado && item.antigoFornec) {
				return item.antigoFornec.razaoSocial
			}
			return item.itemAta.fornecedor.razaoSocial
		},

		getFornecedorNovo(item) {
			if (!item.novoFornec) return '--'
			return item.itemAta.fornecedor.razaoSocial
		},

		getSaldo(item) {
			if (this.aditivoApostila.isEfetivado && item.antigoSaldo) {
				return item.antigoSaldo
			}
			return item.itemAta.estoqueAtual
		},

		excluir() {
			this.$emit('excluir')
		},
		cancelarDescancelar(cancelado) {
			this.$emit('cancelar-descancelar', cancelado)
		},
		getItemClass(item) {
			if (this.estaCancelado(item)) {
				return 'linha-cancelada'
			}
			return ''
		},
		estaCancelado(item) {
			return !!item?.isCancelado
		},
		onSelectAll(value) {
			if (value && !this.isSelecionouTodosItensAditivoApostila) {
				this.$store.commit(mutationTypes.ITEM_ADITIVO_APOSTILA.SET_IS_SELECIONOU_TODOS_ITENS)
				this.itensAditivoApostilaSelecionados = this.itensAditivoApostila
			} else {
				this.$store.commit(mutationTypes.ITEM_ADITIVO_APOSTILA.UNSET_IS_SELECIONOU_TODOS_ITENS)
				this.itensAditivoApostilaSelecionados = []
			}
		},
	},
}
</script>

<style scoped lang="stylus">
.linha-cancelada
	background-color: #f5f5f5 !important;
	color: #9e9e9e !important;

.linha-cancelada td
	color: #9e9e9e !important;
</style>
